import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';

import { KYMW1000Component } from './kymw1000.component';
import { ExecuteLoginService } from './api-services/execute-login.service';
import { GetInfomationService } from './api-services/get-infomation.service';
import { OldLoginService } from './api-services/old-login.service';


/**
 * ログイン画面 モジュール設定クラス
 *
 * @export KYMW1000Module
 * @class KYMW1000Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW1000Component,
  ],
  providers: [
    GetInfomationService,
    ExecuteLoginService,
    OldLoginService,

  ],
})
export class KYMW1000Module {

}
